import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, Injector, OnInit } from '@angular/core'
import { AbstractValueAccessor } from '@mistergreen/shared/angular-directives/abstract-value-accessor'
import { AuthenticationService } from '../../../../../../framework/authentication/services/authentication.service'
import { FormControl, NgControl, NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from '@angular/forms'
import { merge } from 'rxjs'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { filter } from 'rxjs/operators'

@UntilDestroy()
@Component({
    selector: 'mg-checkout-driver',
    templateUrl: './checkout-driver.component.html',
    styleUrls: ['./checkout-driver.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckoutDriverComponent),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => CheckoutDriverComponent),
            multi: true,
        },
    ],
})
export class CheckoutDriverComponent extends AbstractValueAccessor implements OnInit, AfterViewInit {
    userEmailAddress: string
    userIsDriverControl: FormControl
    initialized: boolean = false
    driverEmailAddressControl: FormControl

    constructor(
        private authenticationService: AuthenticationService,
        private inj: Injector,
        private cdRef: ChangeDetectorRef
    ) {
        super()
    }

    public get userIsDriver(): boolean {
        return this.userIsDriverControl && [true, false].indexOf(this.userIsDriverControl.value) !== -1
            ? this.userIsDriverControl.value
            : undefined
    }

    ngOnInit() {
        this.userIsDriverControl = new FormControl(null, Validators.requiredTrue)
        this.driverEmailAddressControl = new FormControl('', Validators.required)

        this.userIsDriverControl.valueChanges.pipe(untilDestroyed(this)).subscribe(userIsDriver => {
            if (userIsDriver === true) {
                this.value = this.userEmailAddress
            } else {
                this.value = this.driverEmailAddressControl.value
            }
            this.cdRef.detectChanges()
        })

        merge(this.driverEmailAddressControl.valueChanges, this.driverEmailAddressControl.statusChanges)
            .pipe(
                untilDestroyed(this),
                filter(() => this.userIsDriverControl.value === false)
            )
            .subscribe(() => {
                this.value = this.driverEmailAddressControl.value
                this.cdRef.detectChanges()
            })
    }

    ngAfterViewInit() {
        this.authenticationService.currentUser.pipe(untilDestroyed(this)).subscribe(user => {
            if (user) {
                const formControl = this.inj.get(NgControl)
                const { value: initialValue } = formControl
                this.userEmailAddress = user.email

                if (initialValue && initialValue.length) {
                    const userIsDriver = initialValue === this.userEmailAddress
                    this.userIsDriverControl.setValue(userIsDriver)
                    this.driverEmailAddressControl.setValue(userIsDriver ? '' : initialValue)
                }

                this.cdRef.detectChanges()
                this.initialized = true
                this.cdRef.detectChanges()

                // forcefully rechecking validity
                formControl.control.updateValueAndValidity()
            }
        })
    }

    async validate(): Promise<any> {
        return this.userIsDriver || this.driverEmailAddressControl.valid ? null : { email: 'invalid' }
    }
}
